<!-- ***Designed by Rahul Kumar***** -->
<!-- ***CP-214*** -->

<!-- Hello datepicker -->
<div class="dhl-datepicer-v2" [formGroup]="frmGroup" #datepicker [class.hidden]="hidden">
    <div #formControlOuter>
        <app-form-field-generic-v2 [toggleActiveIcon]="pickerToggle" *ngIf="configData.type === 'text' " #formControl (controlValue)="onControlValueChange($event)" (fieldAction)="togglePicker()" [fieldMetadata]="datepickerMetadata"
        (input)="setHover(true)" (focusout)="onFocusOutEvent($event)" (keyup.enter)="onFocusOutEvent($event)"
        [frmGroup]="frmGroup" [configData]="configData"></app-form-field-generic-v2>
    </div>

    <div *ngIf="configData.type === 'FILTER' " class="dhl-datepicer-filter-v2" [formGroup]="frmGroup">
        <div *ngIf="configData['lableInside']">
            <div class="filter-wrapper" (click)="togglePicker()">
                <div class="filter-control" [ngClass]="{'label-inside': configData['lableInside'],'new-filter-wrapper':configData['productType'] === 'NEW_FILTER',
                    'small-date': configData['smallDate'], 'active': filterDate && configData['productType'] === 'NEW_FILTER'}">
                    <label class="filter-label-inside">{{configData.label | translate}}</label>
                    <div>
                        <span class="filter-value">{{filterDate | translate}}</span>
                        <span class="default-icon" *ngIf="configData['productType'] != 'NEW_FILTER'">
                            <img  src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,210,24,24))" style="width:24px;height:24px;position:absolute;right:12px;bottom:20px;" type="image/svg+xml" />
                        </span>
                        <span class="dropdown-icons" *ngIf="configData['productType'] === 'NEW_FILTER'">
                            <span [ngClass]="{'show': pickerToggle}" class="active-icon">
                                <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,120,24,24))"
                                    style="width:20px;height:20px" type="image/svg+xml" />
                            </span>
                            <span [ngClass]="{'show': filterDate, 'open': pickerToggle}" class="filled-icon">
                                <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,180,24,24))"
                                    style="width:20px;height:20px" type="image/svg+xml" />
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="!configData['lableInside']">
        <div class="filter-wrapper">
            <label class="filter-label">{{configData.label | translate}}:</label>
            <span (click)="togglePicker()">
            <div class="filter-control">
                <span>{{filterDate | translate}}</span>
            </div>
            <label>
                <span class="default-icon">
                    <img  src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,210,24,24))" style="width:24px;height:24px" type="image/svg+xml" />
                </span>
            </label>
            </span>
        </div>
    </div>
    </div>

    <div #pickerContainer>
        <div *ngIf="pickerToggle" #calendarSection class="picker-container" [ngClass]="{'filter': configData.type === 'FILTER'}">
            <div class="calendar-navigation">
                <div class="left-arrow" (click)="previousMonth()">
                    <span class="default-icon">
                        <img src="../../../../../assets/images/icons-calendar.svg#svgView(viewBox(0,62,20,20))" style="width:20px;height:20px" type="image/svg+xml" />
                    </span>
                </div>
                <div class="month-year">{{months[updatedMonth] | translate}} {{updatedYear}}</div>
                <div class="right-arrow" (click)="nextMonth()">
                    <span class="default-icon">
                        <img src="../../../../../assets/images/icons-calendar.svg#svgView(viewBox(0,92,20,20))" style="width:20px;height:20px" type="image/svg+xml" />
                    </span>
                </div>
            </div>
            <div class="calendar-content">
                <div class="calendar-week">
                    <span class="weekday" *ngFor="let day of week">{{day | translate}}</span>
                </div>

                <div class="calendar-dates" id="calendarDates">
                    <span class="date space" *ngFor="let day of [].constructor(monthFirstDay)">&nbsp;</span>
                    <span [ngClass]="{'disabled': (pastDaysLimit != null && shouldDisableDayByLimit(date, i)) || (minDate && ((i+1 < (futureSelectionDay || currentDate) && currentMonth === updatedMonth && currentYear === updatedYear) || ((currentMonth > updatedMonth && updatedYear === currentYear) || currentYear > updatedYear)))
                         || (maxDate && ((i+1 > currentDate && currentMonth === updatedMonth && currentYear === updatedYear) || ((currentMonth < updatedMonth && updatedYear === currentYear) || currentYear < updatedYear)))
                         || ((compareType === 1 || compareType === 0) && currentDateStatusFun(i+1, updatedMonth, updatedYear, compareType) ) 
                         || (configData?.dateEnabled && !dateEnableFn(i+1, updatedMonth, updatedYear)),
                        'active': (currentDate === i+1 && currentMonth === updatedMonth && currentYear === updatedYear) }" (click)="setSelected($event, i+1)" id="{{i+1}}" class="date" *ngFor="let date of [].constructor(monthTotalDays[updatedMonth]); let i = index">
                        {{i+1}}
                    </span>
                </div>

            </div>

            <div *ngIf="this.configData.timePicker" class='childControls' [ngClass]="{'has-error': !form?.valid && form?.touched}">
                <div *ngFor="let control of (configData.timeControls || configData.child_controls)" class='childArrange'>
                    <app-form-field [configData] = "control" [frmGroup]="getForm()"></app-form-field>
                </div>
            </div>

            <div class="calendar-action">
                <div class="clear">
                    <button type="button" [disabled] = "configData['disableClearButton'] ? true : false" (click)="clearDate(true, $event)" class="dhl-button-v2 buttons-secondary-small-v2">{{commonData.Column_Order_ClearBtn | translate}}</button>
                </div>
                <div class="apply">
                    <button type="button" (click)="setSelectedDate($event)" class="dhl-button-v2 buttons-primary-small-v2">{{commonData.Column_Order_ApplyBtn | translate}}</button>
                </div>
            </div>
        </div>
    </div>

</div>
